var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearchNoResult(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 176,
    viewBox: "0 0 235 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_22134_59710)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.136,
    cy: 40.2,
    rx: 27.2,
    ry: 56,
    transform: "rotate(90 121.136 40.2)",
    fill: "url(#paint0_linear_22134_59710)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter1_f_22134_59710)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 117.136,
    cy: 100.201,
    rx: 96,
    ry: 54.4,
    fill: "url(#paint1_linear_22134_59710)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.1325 119H43.7416C42.7483 119 41.937 119.899 41.937 121C41.937 122.101 42.7483 123 43.7416 123H76.1325C77.1257 123 77.937 122.101 77.937 121C77.937 119.899 77.1257 119 76.1325 119Z",
    fill: "#D7D7DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1325 119H43.7416C42.7483 119 41.937 119.899 41.937 121C41.937 122.101 42.7483 123 43.7416 123H76.1325C77.1257 123 77.937 122.101 77.937 121C77.937 119.899 77.1257 119 76.1325 119Z",
    fill: "url(#paint2_linear_22134_59710)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7112 109H59.4844C58.8732 109 58.3745 109.499 58.3745 110.11C58.3745 110.721 58.8732 111.22 59.4844 111.22H85.7112C86.3224 111.22 86.8211 110.721 86.8211 110.11C86.8211 109.499 86.3224 109 85.7112 109Z",
    fill: "#D7D7DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7112 109H59.4844C58.8732 109 58.3745 109.499 58.3745 110.11C58.3745 110.721 58.8732 111.22 59.4844 111.22H85.7112C86.3224 111.22 86.8211 110.721 86.8211 110.11C86.8211 109.499 86.3224 109 85.7112 109Z",
    fill: "url(#paint3_linear_22134_59710)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M178.898 133H119.976C118.854 133 117.937 133.899 117.937 135C117.937 136.101 118.854 137 119.976 137H178.898C180.021 137 180.937 136.101 180.937 135C180.937 133.899 180.021 133 178.898 133Z",
    fill: "#D7D7DB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.898 133H119.976C118.854 133 117.937 133.899 117.937 135C117.937 136.101 118.854 137 119.976 137H178.898C180.021 137 180.937 136.101 180.937 135C180.937 133.899 180.021 133 178.898 133Z",
    fill: "url(#paint4_linear_22134_59710)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M146.386 142.211H130.084C129.473 142.211 128.974 142.71 128.974 143.321C128.974 143.932 129.473 144.431 130.084 144.431H146.386C146.997 144.431 147.496 143.932 147.496 143.321C147.496 142.71 146.997 142.211 146.386 142.211Z",
    fill: "#D7D7DB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M146.386 142.211H130.084C129.473 142.211 128.974 142.71 128.974 143.321C128.974 143.932 129.473 144.431 130.084 144.431H146.386C146.997 144.431 147.496 143.932 147.496 143.321C147.496 142.71 146.997 142.211 146.386 142.211Z",
    fill: "url(#paint5_linear_22134_59710)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M188.836 124.566H162.609C161.998 124.566 161.5 125.065 161.5 125.676C161.5 126.288 161.998 126.786 162.609 126.786H188.836C189.447 126.786 189.946 126.288 189.946 125.676C189.946 125.065 189.447 124.566 188.836 124.566Z",
    fill: "#D7D7DB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M188.836 124.566H162.609C161.998 124.566 161.5 125.065 161.5 125.676C161.5 126.288 161.998 126.786 162.609 126.786H188.836C189.447 126.786 189.946 126.288 189.946 125.676C189.946 125.065 189.447 124.566 188.836 124.566Z",
    fill: "url(#paint6_linear_22134_59710)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22134_59710)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_22134_59710)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_22134_59710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.723 72.6728C172.896 73.3472 175.98 73.079 178.821 71.5176C178.821 71.5176 188.378 63.589 186.961 59.1306C186.737 58.4191 185.834 57.6497 184.182 57.0099C165.452 49.7664 153.516 73.5005 153.516 73.5005C153.516 73.5005 154.715 75.8628 157.431 78.1434C157.431 78.1434 166.076 85.8992 171.292 85.911C174.55 85.9107 175 83.5235 174.895 81.7113C172.801 81.526 171.456 80.1183 169.544 78.6686C171.368 79.7202 173.007 80.9635 174.99 81.6736C183.892 79.2644 178.787 71.5393 178.787 71.5393C176.452 73.2257 172.714 74.1989 169.69 72.6946L169.723 72.6728Z",
    fill: "url(#paint7_linear_22134_59710)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_22134_59710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.0342 52.158C69.8616 51.4837 67.1528 49.9841 65.193 47.4023C65.193 47.4023 59.6871 36.272 62.7948 32.7754C63.2884 32.2163 64.4266 31.8808 66.1957 31.9682C86.2532 32.9693 87.5039 59.5064 87.5039 59.5064C87.5039 59.5064 85.4476 61.1768 82.039 62.1555C82.039 62.1555 70.9867 65.7245 66.2164 63.6135C63.24 62.288 63.8001 59.9243 64.6331 58.3114C66.6217 58.994 68.4227 58.2549 70.7588 57.7081C68.665 57.9271 66.6622 58.3963 64.562 58.2386C57.4089 52.4166 65.2147 47.4358 65.2147 47.4358C66.6621 49.9262 69.6809 52.3355 73.0559 52.1915L73.0342 52.158Z",
    fill: "url(#paint8_linear_22134_59710)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_iii_22134_59710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.022 82.3083C160.376 68.5184 154.613 56.6983 141.763 49.059C136.414 45.8723 130.477 43.6866 122.559 42.0037C113.897 40.1624 104.84 41.1243 102.264 41.4428C90.9666 42.9099 82.0818 49.7111 77.8551 60.1007C76.6575 63.0218 75.6906 66.0785 74.9444 69.1821C74.308 71.905 73.8371 74.6629 73.5258 77.4837C73.3955 78.6397 73.3262 79.7797 73.251 80.9474C72.5741 94.1701 79.585 105.274 92.5204 111.43C96.7941 113.435 101.455 114.975 106.78 116.106C109.4 116.663 112.1 117.122 115.601 117.606C120.257 118.22 125.341 118.175 130.313 117.442C141.7 115.821 150.899 108.22 154.332 97.6332C154.591 96.8221 154.856 95.9834 155.093 95.1389C155.844 92.5559 156.535 89.8448 157.14 86.9998C157.463 85.4806 157.736 83.9221 158.022 82.3083Z",
    fill: "url(#paint9_linear_22134_59710)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_dif_22134_59710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.224 104.585C105.003 103.688 101.361 102.509 98.0888 100.948C88.3212 96.3022 86.5835 89.1485 86.852 83.9514C87.1376 78.267 88.3611 72.7821 90.4205 67.7057C92.7135 62.0728 97.3872 58.5337 103.587 57.7153C105.011 57.5272 112.484 56.6905 119.133 58.1037C125.588 59.4759 130.06 61.0905 134.08 63.475C141.89 68.1086 144.995 74.2538 143.647 82.224C142.807 87.1264 141.763 91.4948 140.435 95.5718C138.658 101.083 133.932 104.871 127.836 105.741C124.117 106.278 120.361 106.317 116.997 105.862C113.888 105.432 111.492 105.038 109.23 104.557L109.224 104.585ZM107.945 85.7788C107.945 85.7788 108.077 85.8357 108.154 85.881L107.945 85.7788Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.224 104.585C105.003 103.688 101.361 102.509 98.0888 100.948C88.3212 96.3022 86.5835 89.1485 86.852 83.9514C87.1376 78.267 88.3611 72.7821 90.4205 67.7057C92.7135 62.0728 97.3872 58.5337 103.587 57.7153C105.011 57.5272 112.484 56.6905 119.133 58.1037C125.588 59.4759 130.06 61.0905 134.08 63.475C141.89 68.1086 144.995 74.2538 143.647 82.224C142.807 87.1264 141.763 91.4948 140.435 95.5718C138.658 101.083 133.932 104.871 127.836 105.741C124.117 106.278 120.361 106.317 116.997 105.862C113.888 105.432 111.492 105.038 109.23 104.557L109.224 104.585ZM107.945 85.7788C107.945 85.7788 108.077 85.8357 108.154 85.881L107.945 85.7788Z",
    fill: "url(#paint10_radial_22134_59710)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M139.162 83.0534C140.248 76.7223 137.613 72.7371 131.813 69.2881C128.156 67.1293 123.934 65.5987 117.738 64.2818C112.616 63.1931 106.289 63.5752 103.215 63.9578C98.8626 64.5293 95.6261 66.8921 94.0046 70.8647C92.0131 75.7658 90.9185 80.9152 90.6343 86.1793C90.3138 92.1552 93.8456 95.9855 99.1822 98.5013C104.985 101.26 111.25 102.39 117.517 103.233C120.764 103.664 124.183 103.556 127.419 103.093C131.518 102.496 134.715 100.183 135.959 96.3602C137.369 92.0263 138.384 87.5219 139.173 82.9983L139.162 83.0534Z",
    fill: "url(#paint11_linear_22134_59710)",
    stroke: "url(#paint12_linear_22134_59710)",
    strokeWidth: 1.11116
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.7366,
    cy: 85.7558,
    r: 1.23462,
    transform: "rotate(7.78796 97.7366 85.7558)",
    fill: "url(#paint13_linear_22134_59710)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.725,
    cy: 92.4911,
    r: 1.23462,
    transform: "rotate(7.78796 129.725 92.4911)",
    fill: "url(#paint14_linear_22134_59710)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.38,
    cy: 80.0971,
    r: 3.28907,
    transform: "rotate(12 104.38 80.0971)",
    fill: "white",
    stroke: "url(#paint15_linear_22134_59710)",
    strokeWidth: 1.09636
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.901,
    cy: 84.8842,
    r: 3.28907,
    transform: "rotate(12 126.901 84.8842)",
    fill: "white",
    stroke: "url(#paint16_linear_22134_59710)",
    strokeWidth: 1.09636
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.325 86.4048C110.829 84.0358 113.157 82.5235 115.526 83.027C117.895 83.5306 119.408 85.8593 118.904 88.2284L118.448 90.3732C117.945 92.7423 115.616 94.2546 113.247 93.751C110.878 93.2474 109.366 90.9187 109.869 88.5496L110.325 86.4048Z",
    fill: "url(#paint17_linear_22134_59710)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_iii_22134_59710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.956 112.763C120.015 114.613 118.936 116.433 117.725 118.197C117.438 118.598 116.926 118.835 116.351 118.829C110.439 118.698 104.618 117.461 99.1639 115.175C98.6356 114.948 98.2647 114.522 98.1655 114.039C97.7764 111.936 97.5312 109.834 97.4239 107.761C97.3811 106.742 98.4952 106.113 99.3744 106.588C105.614 109.791 112.593 111.274 119.596 110.886C120.62 110.815 121.355 111.838 120.901 112.752L120.956 112.763Z",
    fill: "url(#paint18_linear_22134_59710)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.828 57.5106C124.559 57.2409 124.488 57.1681 124.52 55.9334C124.675 51.405 121.621 48.2731 117.862 46.6947C117.598 46.5808 117.301 46.4887 117.031 46.4024C115.99 46.008 116.19 45.4731 116.259 45.2857C116.323 44.9818 116.382 44.7056 116.557 44.4252C116.807 43.9297 117.325 44.0688 117.567 44.1492C122.798 45.7229 126.24 48.7929 127.33 54.1058C127.487 54.8608 127.467 55.6359 127.452 56.3834C127.436 57.6791 127.208 57.8038 125.883 57.5224L125.828 57.5106Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.828 57.5106C124.559 57.2409 124.488 57.1681 124.52 55.9334C124.675 51.405 121.621 48.2731 117.862 46.6947C117.598 46.5808 117.301 46.4887 117.031 46.4024C115.99 46.008 116.19 45.4731 116.259 45.2857C116.323 44.9818 116.382 44.7056 116.557 44.4252C116.807 43.9297 117.325 44.0688 117.567 44.1492C122.798 45.7229 126.24 48.7929 127.33 54.1058C127.487 54.8608 127.467 55.6359 127.452 56.3834C127.436 57.6791 127.208 57.8038 125.883 57.5224L125.828 57.5106Z",
    fill: "url(#paint19_linear_22134_59710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.789 56.4094C119.603 56.1572 119.63 56.1631 119.584 55.0272C119.469 53.1262 118.395 51.801 116.692 50.8616C116.538 50.7711 116.351 50.7025 116.191 50.6397C115.19 50.1959 115.065 49.9673 115.409 49.0299C115.615 48.4674 115.989 48.2005 116.657 48.3136C119.234 48.8037 120.852 50.4178 121.859 52.5951C122.318 53.5586 122.459 54.6569 122.506 55.7927C122.521 56.4021 122.174 56.6749 121.479 56.556C121.258 56.509 121.037 56.4621 120.817 56.4152L120.789 56.4094Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.789 56.4094C119.603 56.1572 119.63 56.1631 119.584 55.0272C119.469 53.1262 118.395 51.801 116.692 50.8616C116.538 50.7711 116.351 50.7025 116.191 50.6397C115.19 50.1959 115.065 49.9673 115.409 49.0299C115.615 48.4674 115.989 48.2005 116.657 48.3136C119.234 48.8037 120.852 50.4178 121.859 52.5951C122.318 53.5586 122.459 54.6569 122.506 55.7927C122.521 56.4021 122.174 56.6749 121.479 56.556C121.258 56.509 121.037 56.4621 120.817 56.4152L120.789 56.4094Z",
    fill: "url(#paint20_linear_22134_59710)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_22134_59710",
    x: 52.4544,
    y: 0.318181,
    width: 137.364,
    height: 79.764,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.34091,
    result: "effect1_foregroundBlur_22134_59710"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_22134_59710",
    x: -0.000135422,
    y: 24.6644,
    width: 234.273,
    height: 151.073,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5682,
    result: "effect1_foregroundBlur_22134_59710"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_22134_59710",
    x: 61.5435,
    y: 31.9541,
    width: 125.561,
    height: 56.4503,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.49323
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24662
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_59710"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_22134_59710",
    x: 150.495,
    y: 49.5937,
    width: 36.6094,
    height: 39.3379,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.02052,
    dy: 3.02052
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.51026
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.900785 0 0 0 0 0.900785 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_59710"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -6.04104
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.02052
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.483398 0 0 0 0 0.483398 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_59710",
    result: "effect2_innerShadow_22134_59710"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_22134_59710",
    x: 58.5229,
    y: 25.9131,
    width: 28.981,
    height: 41.3887,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.02052,
    dy: 3.02052
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.51026
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.900785 0 0 0 0 0.900785 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_59710"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -6.04104
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.02052
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.483398 0 0 0 0 0.483398 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_59710",
    result: "effect2_innerShadow_22134_59710"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_iii_22134_59710",
    x: 73.2061,
    y: 37.1384,
    width: 85.3311,
    height: 85.6036,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.82586
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.76781
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.158597 0 0 0 0 0.158597 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_59710"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.76781
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.65172
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.775729 0 0 0 0 0.439322 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_59710",
    result: "effect2_innerShadow_22134_59710"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.70977
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.65172
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_22134_59710",
    result: "effect3_innerShadow_22134_59710"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_dif_22134_59710",
    x: 80.178,
    y: 47.3249,
    width: 67.93,
    height: 63.0062,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.66216,
    dy: -4.98647
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.49323
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22134_59710"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22134_59710",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.66216,
    dy: 1.66216
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66216
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.507625 0 0 0 0 0.507625 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_22134_59710"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.07769,
    result: "effect3_foregroundBlur_22134_59710"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_iii_22134_59710",
    x: 97.4229,
    y: 103.601,
    width: 23.6152,
    height: 18.0541,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.82586
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.76781
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.158597 0 0 0 0 0.158597 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_59710"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.82586
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.82586
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.855364 0 0 0 0 0.638409 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_59710",
    result: "effect2_innerShadow_22134_59710"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.88391
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.82586
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_22134_59710",
    result: "effect3_innerShadow_22134_59710"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22134_59710",
    x1: 121.136,
    y1: -15.8,
    x2: 383.878,
    y2: 169.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFADA1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22134_59710",
    x1: 117.136,
    y1: 45.8008,
    x2: 117.136,
    y2: 154.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD79F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22134_59710",
    x1: 61.3934,
    y1: 119.401,
    x2: 61.3932,
    y2: 123.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FFCFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC7B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_22134_59710",
    x1: 73.7486,
    y1: 109.223,
    x2: 73.7485,
    y2: 111.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FFCFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC7B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_22134_59710",
    x1: 151.986,
    y1: 133.401,
    x2: 151.986,
    y2: 137.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FFCFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC7B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_22134_59710",
    x1: 138.984,
    y1: 142.434,
    x2: 138.984,
    y2: 144.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FFCFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC7B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_22134_59710",
    x1: 176.874,
    y1: 124.789,
    x2: 176.874,
    y2: 126.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FFCFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC7B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_22134_59710",
    x1: 173.542,
    y1: 57.6825,
    x2: 167.246,
    y2: 87.2242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFCFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC7B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_22134_59710",
    x1: 75.6425,
    y1: 36.9103,
    x2: 69.3783,
    y2: 66.4588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFCFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC7B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_22134_59710",
    x1: 121.942,
    y1: 50.262,
    x2: 107.024,
    y2: 120.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EE0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8D58"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_22134_59710",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-41.6858 2.77909 -6.0048 -36.1954 134.596 76.9208)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD490"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_22134_59710",
    x1: 119.335,
    y1: 62.7529,
    x2: 111.202,
    y2: 105.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366298,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_22134_59710",
    x1: 103.394,
    y1: 58.7617,
    x2: 121.259,
    y2: 105.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322115,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595864,
    stopColor: "#FFE3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947115,
    stopColor: "#FFF5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_22134_59710",
    x1: 97.7366,
    y1: 84.5212,
    x2: 97.7366,
    y2: 86.9904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_22134_59710",
    x1: 129.725,
    y1: 91.2565,
    x2: 129.725,
    y2: 93.7257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_22134_59710",
    x1: 104.38,
    y1: 76.2599,
    x2: 104.38,
    y2: 83.9343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAD9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFAAAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_22134_59710",
    x1: 126.901,
    y1: 81.047,
    x2: 126.901,
    y2: 88.7215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAD9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFAAAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_22134_59710",
    x1: 114.934,
    y1: 85.8153,
    x2: 113.657,
    y2: 91.8207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6164"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_22134_59710",
    x1: 109.542,
    y1: 108.614,
    x2: 104.329,
    y2: 133.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EE0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8D58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_22134_59710",
    x1: 117.114,
    y1: 44.5728,
    x2: 112.325,
    y2: 60.4935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFC9C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_22134_59710",
    x1: 115.933,
    y1: 48.4889,
    x2: 112.968,
    y2: 58.3859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFC9C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22134_59710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132.903,
    height: 78.0805,
    fill: "white",
    transform: "translate(61.0542 27.6025) rotate(12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchNoResult);
export default __webpack_public_path__ + "static/media/icon-search-no-result.dd89009433e6ab019a75dd13771fe696.svg";
export { ForwardRef as ReactComponent };